<style lang="less" scoped>
  @import "../../../style/theme.less";

  h1 {
    font-family: "Kaushan Script", cursive;
    font-weight: 400;
    font-size: 28px;
  }

  .action-button {
    font-family: "Kaushan Script", cursive;
    font-weight: 600;
  }
</style>

<template>
  <div>
    <h1>Welcome!</h1>
    <p>
      You are about to embark on a journey of self-discovery, empowering yourself with self-knowledge and a greater sense of choice and control in your life.<br><br>
      Answer from your true self, not who you wish you were or think or heard you should be.<br><br>
      Agree or disagree, fully or somewhat, or choose the middle 'neither' option based on your initial, instinctive reaction to the statement - Be true to your sacred self!
    </p>

    <question :startValue="4" :neverDone="true" />

    <div v-if="!disableInput">
      <a-divider />
      <p>
        To begin your journey, please enter your license key below:
      </p>
      <a-input
        placeholder="License Key"
        :disabled="disableInput"
        :value="licenseKey"
        @change="({ srcElement: { value }}) => setLicenseKey(value)"
        @pressEnter="start"
      />
    </div>
    <div class="spacer-lg" />
    <a-button
      class="action-button"
      size="large"
      shape="round"
      type="primary"
      :loading="loading"
      @click="start"
      :disabled="!licenseKey || licenseKey.length === 0"
    >
      Let's Begin!
    </a-button>
  </div>
</template>

<script>
import question from '../questions/question/';

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'user.landing',

  data: () => ({
    disableInput: false,
  }),

  mounted() {
    const licenseKey = this.$route.query.license;
    if (licenseKey) {
      this.setLicenseKey(licenseKey);
      this.disableInput = true;
    }

    return this.listConstants();
  },

  computed: {
    ...mapState('user', ['licenseKey', 'loading',]),

    showAllMarks() {
      return window.innerWidth > 600;
    },
  },

  components: {
    question,
  },

  methods: {
    ...mapActions('user', ['getSubmission', 'listConstants',]),
    ...mapMutations('user', ['setLicenseKey',]),

    start() {
      return this.getSubmission()
        .then(submission => {
          if (submission.completed) {
            this.$router.push({ name: 'user.report', });
          } else if (submission.id) {
            this.$router.push({ name: 'user.questions', });
          } else {
            this.$router.push({ name: 'user.start', });
          }
        });
    },
  },
};
</script>
